import React from 'react';
import { Table, Badge, Button, SortableTh } from '@/components/ui';
import { Vehicle } from '../../../types/Vehicle';
import VehicleProfilePreview from './VehicleProfilePreview';

interface VehiclesTableProps {
  vehicles: Vehicle[];
  onSelectVehicle?: (vehicle: Vehicle) => void;
  sortBy?: string | null;
  sortDir?: 'asc' | 'desc';
  onSort?: (key: string, dir: 'asc' | 'desc') => void;
}

const VehiclesTable: React.FC<VehiclesTableProps> = ({ vehicles, onSelectVehicle, sortBy = null, sortDir = 'asc', onSort }) => {
  const handleRowClick = (vehicle: Vehicle) => {
    if (onSelectVehicle) {
      onSelectVehicle(vehicle);
    }
  };

  return (
    <Table hover responsive>
        <thead>
          <tr>
            <SortableTh label="Unit Number" sortKey="unitNumber" activeKey={sortBy} direction={sortDir} onSort={onSort} />
            <SortableTh label="Description" sortKey="description" activeKey={sortBy} direction={sortDir} onSort={onSort} />
            <SortableTh label="Vehicle Type" sortKey="vehicleType" activeKey={sortBy} direction={sortDir} onSort={onSort} />
            <SortableTh label="Vehicle Classification" sortKey="vehicleClassification" activeKey={sortBy} direction={sortDir} onSort={onSort} />
            <SortableTh label="Current Status" sortKey="currentStatus" activeKey={sortBy} direction={sortDir} onSort={onSort} />
            <th>Service Areas</th>
            <th>Profile</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {vehicles.length === 0 ? (
            <tr>
              <td colSpan={8} className="tw-text-center tw-py-4">
                No vehicles found
              </td>
            </tr>
          ) : (
            vehicles.map((vehicle) => (
              <tr key={vehicle.id} onClick={() => handleRowClick(vehicle)} style={{ cursor: 'pointer' }}>
                <td>{vehicle.unitNumber}</td>
                <td>{vehicle.description || '-'}</td>
                <td>{vehicle.vehicleType || '-'}</td>
                <td>{vehicle.vehicleClassification || '-'}</td>
                <td>
                  <Badge bg={vehicle.currentStatus === 'In Service' ? 'success' : 'secondary'}>
                    {vehicle.currentStatus || vehicle.status}
                  </Badge>
                </td>
                <td>
                  {vehicle.vehicleServiceAreas && vehicle.vehicleServiceAreas.length > 0
                    ? vehicle.vehicleServiceAreas.map(sa => sa.serviceArea.name).join(', ')
                    : '-'}
                </td>
                <td>
                  {vehicle.vehicleProfile ? (
                    <div className="tw-flex tw-items-center">
                      <span>{vehicle.vehicleProfile.inspection}</span>
                      <VehicleProfilePreview profile={vehicle.vehicleProfile} />
                    </div>
                  ) : (
                    '-'
                  )}
                </td>
                <td>
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRowClick(vehicle);
                    }}
                  >
                    View
                  </Button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
  );
};

export default VehiclesTable;

